import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
import { Services, ServiceDetail } from "./pages/Services";
import { About, Contact, FAQ, Mission, Pricing } from "./pages/CompanyPages";
import { Accessibility, NotFound, Privacy } from "./pages/UtilityPages";

export function App() {
  return (
    <Routes>
      <Route element={<Layout/>}>
        <Route index element={<Home/>}/>
        <Route path="services" element={<Services/>}/>
        <Route path="services/:slug" element={<ServiceDetail/>}/>
        <Route path="website-solutions" element={<ServiceDetail fixedSlug="website-solutions"/>}/>
        <Route path="hosting-email" element={<ServiceDetail fixedSlug="hosting-email"/>}/>
        <Route path="seo-online-visibility" element={<ServiceDetail fixedSlug="seo-online-visibility"/>}/>
        <Route path="digital-marketing" element={<ServiceDetail fixedSlug="digital-marketing"/>}/>
        <Route path="ai-automation" element={<ServiceDetail fixedSlug="ai-automation"/>}/>
        <Route path="business-tools" element={<ServiceDetail fixedSlug="business-tools"/>}/>
        <Route path="about" element={<About/>}/>
        <Route path="mission" element={<Mission/>}/>
        <Route path="pricing" element={<Pricing/>}/>
        <Route path="faq" element={<FAQ/>}/>
        <Route path="contact" element={<Contact/>}/>
        <Route path="schedule" element={<Contact schedule/>}/>
        <Route path="privacy" element={<Privacy/>}/>
        <Route path="accessibility" element={<Accessibility/>}/>
        <Route path="404" element={<NotFound/>}/>
        <Route path="*" element={<NotFound/>}/>
      </Route>
    </Routes>
  );
}
